import DashboardFilters from './DashboardFilters';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  ClipboardList,
  CheckCircle,
  Activity,
  Pending,
  AlertTriangle,
  Award,
  Users,
  PieChart,
  Send,
} from '../../../shared/assets/AppIcons';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart as RechartsPieChart,
  Pie,
  Cell,
} from 'recharts';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui/card';
import { Badge } from '@/shared/ui/badge';
import { getRoutePath, ROUTE_IDS } from '@/app/router/route-registry';
import DashboardCustomTooltip from '@/modules/dashboard/components/DashboardCustomTooltip';
import { getChartColor } from '@/modules/dashboard/utils/dashboard.helpers';
import '@/modules/dashboard/styles/AssignmentsSection.css';

export default function AssignmentsSection({
  incarichiStats,
  incarichiPerStatusData,
  incarichiPerMittenteData,
  incarichiPerTipoData,
  incarichiPerUrgenzaData,
  staffPerformance,
  staffPerformanceStatus = 'available',
  staffPerformanceError = '',
  incarichiDateRange,
  setIncarichiDateRange,
  isIncarichiCalendarOpen,
  setIsIncarichiCalendarOpen,
  applyIncarichiPreset,
  incarichiDateRangeLabel,
}) {
  const [filterToolbarContainer, setFilterToolbarContainer] = useState(null);
  const assignmentsPath = getRoutePath(ROUTE_IDS.ASSIGNMENTS);
  const chartColors = {
    grid: 'var(--chart-available)',
    axis: 'var(--text-secondary)',
    received: 'var(--chart-info)',
    inProgress: 'var(--chart-warning)',
    completed: 'var(--chart-success)',
  };

  return (
    <Card className="assignments-section">
      <CardHeader>
        <div className="assignments-section__header">
          <div className="assignments-section__title-wrap">
            <CardTitle className="assignments-section__title">
              <Activity className="assignments-section__title-icon" size={16} />
              Gestione Tasks
            </CardTitle>
            <CardDescription className="assignments-section__description">
              Panoramica delle attività del team e performance
            </CardDescription>
          </div>

          <div className="assignments-section__actions">

            <Link to={assignmentsPath}>
              <Badge variant="outline" className="assignments-section__link-badge">
                <ClipboardList size={16} />
                Vai a Tasks
              </Badge>
            </Link>
            <div ref={setFilterToolbarContainer} className="dashboard-section-filter-actions" />
          </div>
        </div>
      </CardHeader>

      <CardContent>
        <div className="dashboard-section-filters">
          <span className="dashboard-section-filters__period">{incarichiDateRangeLabel}</span>
          <DashboardFilters toolbarContainer={filterToolbarContainer} label="Filtri task" assignments={{ range: incarichiDateRange, setRange: setIncarichiDateRange, applyPreset: applyIncarichiPreset }} />
        </div>
        <div className="assignments-section__kpi-grid">
          <div className="assignments-section__kpi-card assignments-section__kpi-card--neutral">
            <div className="assignments-section__kpi-icon-wrap">
              <ClipboardList
                size={16}
                className="assignments-section__kpi-icon assignments-section__kpi-icon--neutral"
              />
            </div>
            <p className="assignments-section__kpi-value assignments-section__kpi-value--neutral">
              {incarichiStats.totale}
            </p>
            <p className="assignments-section__kpi-label">Totale</p>
          </div>

          <div className="assignments-section__kpi-card assignments-section__kpi-card--success">
            <div className="assignments-section__kpi-icon-wrap">
              <CheckCircle
                size={16}
                className="assignments-section__kpi-icon assignments-section__kpi-icon--success"
              />
            </div>
            <p className="assignments-section__kpi-value assignments-section__kpi-value--success">
              {incarichiStats.completati}
            </p>
            <p className="assignments-section__kpi-label assignments-section__kpi-label--success">
              Completati
            </p>
          </div>

          <Link to={`${assignmentsPath}?scope=team&assignmentTab=in_corso`} className="assignments-section__kpi-card assignments-section__kpi-card--warning">
            <div className="assignments-section__kpi-icon-wrap">
              <Activity
                size={16}
                className="assignments-section__kpi-icon assignments-section__kpi-icon--warning"
              />
            </div>
            <p className="assignments-section__kpi-value assignments-section__kpi-value--warning">
              {incarichiStats.inCorso}
            </p>
            <p className="assignments-section__kpi-label assignments-section__kpi-label--warning">
              In Corso
            </p>
          </Link>

          <div className="assignments-section__kpi-card assignments-section__kpi-card--neutral">
            <div className="assignments-section__kpi-icon-wrap">
              <Pending
                size={16}
                className="assignments-section__kpi-icon assignments-section__kpi-icon--neutral"
              />
            </div>
            <p className="assignments-section__kpi-value assignments-section__kpi-value--neutral">
              {incarichiStats.daAccettare}
            </p>
            <p className="assignments-section__kpi-label assignments-section__kpi-label--neutral">
              Da Accettare
            </p>
          </div>

          <Link to={`${assignmentsPath}?scope=team&assignmentTab=scadute`} className="assignments-section__kpi-card assignments-section__kpi-card--danger">
            <div className="assignments-section__kpi-icon-wrap">
              <AlertTriangle
                size={16}
                className="assignments-section__kpi-icon assignments-section__kpi-icon--danger"
              />
            </div>
            <p className="assignments-section__kpi-value assignments-section__kpi-value--danger">
              {incarichiStats.inRitardo}
            </p>
            <p className="assignments-section__kpi-label assignments-section__kpi-label--danger">
              In ritardo
            </p>
          </Link>

          <div className="assignments-section__kpi-card assignments-section__kpi-card--success">
            <div className="assignments-section__kpi-icon-wrap">
              <Award
                size={16}
                className="assignments-section__kpi-icon assignments-section__kpi-icon--success"
              />
            </div>
            <p className="assignments-section__kpi-value assignments-section__kpi-value--success">
              {incarichiStats.tassoCompletamento}%
            </p>
            <p className="assignments-section__kpi-label assignments-section__kpi-label--success">
              Completamento
            </p>
          </div>
        </div>

        <div className="assignments-section__charts-grid">
          <div className="assignments-section__chart-box">
            <Link to={`${assignmentsPath}?scope=team&assignmentTab=in_corso`} className="assignments-section__chart-title">
              <Users size={16} className="assignments-section__chart-title-icon" />
              Performance Team
            </Link>

            {staffPerformanceStatus === 'unavailable' ? (
              <div className="assignments-section__chart-state" role="status">
                {staffPerformanceError || 'Performance Team non disponibile dal backend.'}
              </div>
            ) : staffPerformance.length === 0 ? (
              <div className="assignments-section__chart-state" role="status">
                Nessuna performance team disponibile per il periodo selezionato.
              </div>
            ) : (
              <ResponsiveContainer width="100%" height={220}>
                <BarChart data={staffPerformance} layout="vertical">
                  <CartesianGrid strokeDasharray="3 3" stroke={chartColors.grid} />
                  <XAxis type="number" allowDecimals={false} tick={{ fontSize: 11 }} stroke={chartColors.axis} />
                  <YAxis
                    dataKey="name"
                    type="category"
                    tick={{ fontSize: 11 }}
                    stroke={chartColors.axis}
                    width={60}
                  />
                  <Tooltip
                    content={({ active, payload, label }) => {
                      if (!active || !payload || !payload.length) return null;

                      const data = payload[0]?.payload;

                      return (
                        <div className="assignments-section__tooltip">
                          <p className="assignments-section__tooltip-title">{data?.fullName}</p>

                          {payload.map((entry, index) => (
                            <div key={index} className="assignments-section__tooltip-row">
                              <div
                                className="assignments-section__tooltip-dot"
                                style={{ backgroundColor: entry.color }}
                              />
                              <span className="assignments-section__tooltip-label">
                                {entry.name}:
                              </span>
                              <span className="assignments-section__tooltip-value">
                                {entry.value}
                              </span>
                            </div>
                          ))}
                        </div>
                      );
                    }}
                  />
                  <Legend />
                  <Bar
                    isAnimationActive={false}
                    dataKey="ricevuti"
                    name="Ricevuti"
                    fill={chartColors.received}
                    radius={[0, 4, 4, 0]}
                  />
                  <Bar
                    isAnimationActive={false}
                    dataKey="inCorso"
                    name="In Corso"
                    fill={chartColors.inProgress}
                    radius={[0, 4, 4, 0]}
                  />
                  <Bar
                    isAnimationActive={false}
                    dataKey="completati"
                    name="Completati"
                    fill={chartColors.completed}
                    radius={[0, 4, 4, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            )}
          </div>

          <div className="assignments-section__chart-box">
            <h4 className="assignments-section__chart-title">
              <PieChart
                size={16}
                className="assignments-section__chart-title-icon assignments-section__chart-title-icon--secondary"
              />
              Distribuzione Tasks
            </h4>

            <div className="assignments-section__pie-grid">
              <div className="assignments-section__pie-item">
                <p className="assignments-section__pie-label">Per Status</p>
                {incarichiPerStatusData.some((entry) => entry.value > 0) ? <ResponsiveContainer width="100%" minWidth={0} height={120}>
                  <RechartsPieChart>
                    <Pie
                      isAnimationActive={false}
                      data={incarichiPerStatusData}
                      cx="50%"
                      cy="50%"
                      innerRadius={25}
                      outerRadius={45}
                      dataKey="value"
                    >
                      {incarichiPerStatusData.map((entry, index) => (
                        <Cell key={`status-${index}`} fill={getChartColor(entry.colorKey)} />
                      ))}
                    </Pie>
                    <Tooltip content={<DashboardCustomTooltip valueFormatter={(value) => String(value)} />} />
                  </RechartsPieChart>
                </ResponsiveContainer> : <p role="status" className="assignments-section__chart-state">Nessun dato nel periodo</p>}
              </div>

              <div className="assignments-section__pie-item">
                <p className="assignments-section__pie-label">Chi Assegna</p>
                {incarichiPerMittenteData.some((entry) => entry.value > 0) ? <ResponsiveContainer width="100%" minWidth={0} height={120}>
                  <RechartsPieChart>
                    <Pie
                      isAnimationActive={false}
                      data={incarichiPerMittenteData}
                      cx="50%"
                      cy="50%"
                      innerRadius={25}
                      outerRadius={45}
                      dataKey="value"
                    >
                      {incarichiPerMittenteData.map((entry, index) => (
                        <Cell key={`mittente-${index}`} fill={getChartColor(entry.colorKey)} />
                      ))}
                    </Pie>
                    <Tooltip content={<DashboardCustomTooltip valueFormatter={(value) => String(value)} />} />
                  </RechartsPieChart>
                </ResponsiveContainer> : <p role="status" className="assignments-section__chart-state">Nessun dato nel periodo</p>}
              </div>

              <div className="assignments-section__pie-item">
                <p className="assignments-section__pie-label">Per Tipo</p>
                {incarichiPerTipoData.some((entry) => entry.value > 0) ? <ResponsiveContainer width="100%" minWidth={0} height={120}>
                  <RechartsPieChart>
                    <Pie
                      isAnimationActive={false}
                      data={incarichiPerTipoData}
                      cx="50%"
                      cy="50%"
                      innerRadius={25}
                      outerRadius={45}
                      dataKey="value"
                    >
                      {incarichiPerTipoData.map((entry, index) => (
                        <Cell key={`tipo-${index}`} fill={getChartColor(entry.colorKey)} />
                      ))}
                    </Pie>
                    <Tooltip content={<DashboardCustomTooltip valueFormatter={(value) => String(value)} />} />
                  </RechartsPieChart>
                </ResponsiveContainer> : <p role="status" className="assignments-section__chart-state">Nessun dato nel periodo</p>}
              </div>

              <div className="assignments-section__pie-item">
                <p className="assignments-section__pie-label">Per Urgenza</p>
                {incarichiPerUrgenzaData.some((entry) => entry.value > 0) ? <ResponsiveContainer width="100%" minWidth={0} height={120}>
                  <RechartsPieChart>
                    <Pie
                      isAnimationActive={false}
                      data={incarichiPerUrgenzaData}
                      cx="50%"
                      cy="50%"
                      innerRadius={25}
                      outerRadius={45}
                      dataKey="value"
                    >
                      {incarichiPerUrgenzaData.map((entry, index) => (
                        <Cell key={`urgenza-${index}`} fill={getChartColor(entry.colorKey)} />
                      ))}
                    </Pie>
                    <Tooltip content={<DashboardCustomTooltip valueFormatter={(value) => String(value)} />} />
                  </RechartsPieChart>
                </ResponsiveContainer> : <p role="status" className="assignments-section__chart-state">Nessun dato nel periodo</p>}
              </div>
            </div>
          </div>
        </div>

        <div className="assignments-section__footer">
          <h4 className="assignments-section__footer-title">
            <Send size={16} className="assignments-section__footer-title-icon" />
            Top Assegnanti
          </h4>

          <div className="assignments-section__top-grid">
            {incarichiPerMittenteData.slice(0, 4).map((mittente, index) => (
              <div key={index} className="assignments-section__top-item">
                <div className="assignments-section__top-item-left">
                  <div
                    className="assignments-section__top-item-dot"
                    style={{ backgroundColor: getChartColor(mittente.colorKey) }}
                  />
                  <span className="assignments-section__top-item-name">{mittente.name}</span>
                </div>
                <Badge variant="secondary" className="assignments-section__top-item-badge">
                  {mittente.value}
                </Badge>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
